import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    icon: 'ri-user-add-line',
    title: '注册账号',
    desc: '使用手机号或邮箱快速注册，完善个人资料和偏好设置，开启你的91牛之旅。',
  },
  {
    step: '02',
    icon: 'ri-search-line',
    title: '探索功能',
    desc: '浏览平台核心功能，使用智能匹配引擎找到最适合你的资源与服务。',
  },
  {
    step: '03',
    icon: 'ri-rocket-line',
    title: '高效使用',
    desc: '将91牛融入日常工作流程，利用数据分析和团队协作功能提升整体效率。',
  },
  {
    step: '04',
    icon: 'ri-heart-line',
    title: '分享成长',
    desc: '加入用户社区，分享你的使用心得，邀请好友一起体验91牛带来的价值。',
  },
];

export default function Guide() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            使用指南
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            4步开启91牛之旅
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            简单四步，快速上手91牛平台，开启高效便捷的全新体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div key={s.step} className="relative text-center">
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-secondary-100 rounded-full mb-5">
                <i className={`${s.icon} text-2xl text-secondary-600`} />
              </div>
              <div className="text-xs font-bold text-primary-500 mb-2">{s.step}</div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {s.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%]">
                  <div className="border-t-2 border-dashed border-background-300" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/category/tutorial"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-secondary-500 hover:bg-secondary-600 text-background-50 font-medium px-6 py-3 rounded-full text-sm transition-colors cursor-pointer"
          >
            查看详细教程
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}